<script setup lang="ts">
import { type PropType } from 'vue';

type Channel = {
  actual: boolean;
  target: boolean;
  reset: boolean;
  error: boolean;
}

const props = defineProps({
  state: {
    type: Object as PropType<Channel>,
    required: true,
  },
  pending: {
    type: Boolean,
    required: true,
  },
  click: {
    type: Function as PropType<() => void>,
    required: true
  },
});
</script>

<template>
  <div
    class="flex w-20 rounded-full h-11 border-2 border-input justify-end my-2 p-[2px]"
    :class="{
      'cursor-pointer': !props.pending && props.state,
      'cursor-wait': props.pending,
    }"
    @click="props.click"
  >
    <div
      v-if="props.state"
      class="w-9 h-full rounded-full transition-all duration-200 transform"
      :class="{
        'animate-pulse': props.pending,
        'bg-success': props.state.target,
        'bg-muted-foreground': !props.state.target,
        'translate-x-0': props.state.target,
        '-translate-x-9': !props.state.target
      }"
    />
  </div>
</template>
